enum SlideType {
	WelcomeSlide = 'welcomeSlide',
	HomeSlide = 'homeSlide',
	ThankYouSlide = 'thankYouSlide',
	HighlightSlide = 'highlightSlide',
	ChapterOverviewSlide = 'chapterOverviewSlide',
	MaskedOverviewSlide = 'maskedOverviewSlide',
	TravelPassSlide = 'travelPassSlide',
	TravelPassVipSlide = 'travelPassVipSlide',
	OfferASlide = 'offerASlide',
	OfferBSlide = 'offerBSlide',
	OfferCSlide = 'offerCSlide',
	OfferDSlide = 'offerDSlide',
	OfferESlide = 'offerESlide',
	CustomSlide = 'customSlide',
	CooperationSlide = 'cooperationSlide',
	SingleMediaSlide = 'singleMediaSlide',
	TrainRouteSlide = 'trainRouteSlide',
	RoutePricesSlide = 'routePricesSlide',
	SkiRegionSlide = 'skiRegionSlide'
}

export default SlideType;
